import React from "react";
import { connect } from "react-redux";
import {
  fetchReconciliation,
  fetchReconciliationActivities,
  fetchReconciliationSettlements,
} from "../../queries/reconciliation/reconciliationQuery";
import language from "../../language";
import { Table } from "../Table";
import { Modal } from "../Modal";
import icons from "../../constants/icons";
import { getStorage } from "../../utils/storage";
import ProcessReport from "./ProcessReport";

class Activities extends React.Component {
  state = {
    isLoading: false,
    selectedData: {},
    data: [],
    page: 0,
    limit: 10,
  };

  componentDidMount() {
    this.getData(true);
  }

  filtersParams = async () => {
    let { filters = {}, reconciliationPublicId } = this.props;
    const { page, limit } = this.state;

    const { merchantID } = await getStorage("merchantID");

    let params = {
      merchantId: merchantID,
      page,
      size: limit,
      reconciliationPublicId,
    };

    if (filters.startDate && filters.endDate) {
      params.startDate = filters.startDate;
      params.endDate = filters.endDate;
    }

    if (filters.type) {
      params.type = filters.type.value;
    }
    return params;
  };

  getData = async (isLoading) => {
    const { defaultLanguage } = this.props;
    const params = await this.filtersParams();

    try {
      this.setState({ isLoading });

      const data = await fetchReconciliationActivities(defaultLanguage, params);

      this.setState({
        isLoading: false,
        data: data.content,
        totalPageCount: data.totalPages,
        page: data.number,
        limit: data.numberOfElements,
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  handlePagination(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].type,
        key: "type",
        type: "status",
      },
      {
        title: language[this.props.defaultLanguage].description,
        key: "description",
      },
      {
        title: language[this.props.defaultLanguage].created_by,
        key: "createdBy",
      },
      {
        title: "Created At",
        key: "dateCreated",
        formatTime: "lll",
        isMoment: true,
      },
    ];

    return headers;
  }

  render() {
    return (
      <div className="card-body">
        <Table
          data={this.state.data}
          page={this.state.page}
          limit={this.state.limit}
          totalPageCount={this.state.totalPageCount}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(Activities);
